module.exports = __webpack_public_path__ + "static/media/6_licious.e86b8bb4.svg";